const valuesMap = () =>{
    return {
     PADDING_LEFT : document.getElementsByClassName('search-dealers')[0] ?( document.documentElement.clientWidth>=768 
     ? document.getElementsByClassName('search-dealers')[0].getBoundingClientRect().right+30 :30):0,
    COUNTRY: 'ES'
}
}
const domElements = ()=>{ 
    return {
    MAP:document.getElementById('map'),
    INPUT:document.getElementById('searcher-input')
}
}
const parameters = {

    getDealers:{
        count:20,
        distance:200,
        maxCount:300,
        maxDistance:2000,
        centerCoords:[-3.7,40.41],
        currentLocation:false
    }
}

const isCanary=(postalCode='',region='')=>

    ((postalCode.startsWith('35')|| postalCode.startsWith('38')) ||
    (region === 'Canary Islands')) 


  const   getUrlVars=() =>{
        /* Obtiene los parámetros que hayan llegado en la URL */
        var vars = [], hash;
        var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        for (var i = 0; i < hashes.length; i++) {
          hash = hashes[i].split('=');
          vars.push(hash[0]);
          vars[hash[0]] = decodeURIComponent(hash[1]);
        }
        return vars;
      }


export {valuesMap,domElements,parameters,isCanary,getUrlVars}